var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3615",
    opacity: 0.3,
    filter: "url(#filter0_f_8008_126915)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112.138,
    cy: 112.14,
    r: 82.7007,
    transform: "rotate(-106.868 112.138 112.14)",
    fill: "url(#paint0_linear_8008_126915)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8008_126915",
    x: 0.814062,
    y: 0.817968,
    width: 222.645,
    height: 222.643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.3,
    result: "effect1_foregroundBlur_8008_126915"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8008_126915",
    x1: 112.138,
    y1: 29.4391,
    x2: 194.838,
    y2: 112.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#053CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989012,
    stopColor: "#FDB62F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCli);
export default __webpack_public_path__ + "static/media/cli.5ae827bb7553379f721553791fe2decd.svg";
export { ForwardRef as ReactComponent };